import "./App.css";
import { Route, Routes, Navigate } from "react-router-dom";
import Sidebar from "./pages/Performance Dashboard/sideBar";
import Performance from "./pages/Performance Dashboard/PerformanceDashboard";
import WorkInProgress from "./pages/WorkInProgress/WorkInProgress";
import ItemDetails from "./pages/itemDetails";
import ReleaseComparison from "./pages/Release Comparison/ReleaseComparison";
import LoginPage from "./pages/login/LoginPage";
import { useContext, useEffect, useRef } from "react";
import { MyContext } from "./context/myContext";
import { getProductList, readToken } from "./utils/DataService";
import TeamConfig from "./pages/team-config/TeamConfig";
import UserConfig from "./pages/config/UserConfig";
import TargetConfig from "./pages/config/TargetConfig";
import "react-toastify/dist/ReactToastify.css";
import "./toastify-custom.css";
import { ToastContainer, cssTransition } from "react-toastify";
import WorkItemConfig from "./pages/workitem-config/WorkItemConfig";
import { singleSignInUrl } from "./api/auth";

function App() {
  const { isAuthenticated, setSelectedProduct } = useContext(MyContext);
  const samlCheckPerformed = useRef(false);

  
  useEffect(() => {
    const productList = getProductList() ? JSON.parse(getProductList()) : [];
    setSelectedProduct(productList?.find((item) => item?.isSelected)?.name ?? productList[0]?.name);
  }, []);

  useEffect(() => {
    const checkAuth = () => {
      // Skip auth check if already performed, have token, handling SAML callback, 
      // in MSAL flow, or already on login page
      if (samlCheckPerformed.current || 
          readToken() || 
          new URLSearchParams(window.location.search).has('token') ||
          window.location.pathname.includes('/login')) {
        return;
      }
      
      samlCheckPerformed.current = true;

      // Single form submission that lets backend handle SAML check + redirect
      const form = document.getElementById('auth-check-form');
      if (form) {
        form.submit(); // Backend will either redirect to SAML or return to /login
      }
    };
    
    checkAuth();
  }, []);

  const Slide = cssTransition({
    enter: "slideInUp",
    exit: "slideOutDown",
    collapseDuration: 300,
  });

  // Check if we have a token in the URL (SAML callback)
  const urlParams = new URLSearchParams(window.location.search);
  const hasTokenInUrl = urlParams.has('token');

  // If we have a token in URL, let LoginPage handle it
  if (hasTokenInUrl) {
    return <LoginPage />;
  }

  return (
    <>
      <ToastContainer
        hideProgressBar={true}
        position="bottom-right"
        transition={Slide}
        icon={false}
        pauseOnFocusLoss={false}
        closeButton={true}
        autoClose={4500}
        pauseOnHover={false}
      />

      <form 
        id="auth-check-form"
        action={singleSignInUrl}
        method="post"
        style={{ display: 'none' }}
      >
      </form>

      <Routes>
        {/* Public Route */}
        <Route path="/login" element={<LoginPage />} />

        {/* Protected Routes */}
        {isAuthenticated ? (
          <Route
            path="*"
            element={
              <div className="app-container">
                <div className="sidebar-container">
                  <Sidebar />
                </div>
                <div className="content-container flex-grow">
                  <Routes>
                    <Route path="/" element={localStorage.getItem("activeScreenPath") ? <Navigate to={localStorage.getItem("activeScreenPath")} /> : <Navigate to="/performance-dashboard" />} />
                    <Route path="/work-item" element={<ItemDetails />} />
                    <Route path="/performance-dashboard" element={<Performance />} />
                    <Route path="/work-in-progress" element={<WorkInProgress />} />
                    <Route path="/release-comparison" element={<ReleaseComparison />} />
                    <Route path="/team-configuration" element={<TeamConfig />} />
                    <Route path="/user-configuration" element={<UserConfig />} />
                    <Route path="/workitem-configuration" element={<WorkItemConfig />} />
                    <Route path="/target-configuration" element={<TargetConfig />} />
                  </Routes>
                </div>
              </div>
            }
          />
        ) : (
          <Route path="*" element={<Navigate to="/" replace />} />
        )}
      </Routes>
    </>
  );
}

export default App;
